import { Component, OnDestroy, OnInit } from '@angular/core';
import { FastTrackRouteQueryParams } from '@lsq-frontend/fasttrack-shared/app-constants';
import { forLifeOf, LifecycleAware } from '@lsq-frontend/common-ui';
import { LoginPageStep, LoginService } from './login.service';

@LifecycleAware()
@Component({
    selector: 'login-page',
    styleUrls: ['./login-page.component.scss'],
    template: `
        <div class="login-page">
            <lsq-circle-loader *ngIf="isLoading"></lsq-circle-loader>
            <div *ngIf="!isLoading">
                <sign-in
                    *ngIf="(loginPageStep$ | async) === loginPageStep.SignIn"
                    [showPasswordReset]="displayPasswordReset"
                ></sign-in>

                <forced-reset-password
                    *ngIf="(loginPageStep$ | async) === loginPageStep.ForcedResetPassword"
                ></forced-reset-password>

                <forgot-password
                    *ngIf="(loginPageStep$ | async) === loginPageStep.ForgotPassword"
                ></forgot-password>

                <forgot-password-verification
                    *ngIf="(loginPageStep$ | async) === loginPageStep.ForgotPasswordVerification"
                ></forgot-password-verification>

                <mfa-registration
                    *ngIf="(loginPageStep$ | async) === loginPageStep.MfaRegistration"
                ></mfa-registration>

                <mfa-code *ngIf="(loginPageStep$ | async) === loginPageStep.Mfa"></mfa-code>

                <sms-mfa-registration
                    *ngIf="(loginPageStep$ | async) === loginPageStep.SmsMfaRegistration"
                ></sms-mfa-registration>

                <totp-mfa-registration
                    *ngIf="(loginPageStep$ | async) === loginPageStep.TotpMfaRegistration"
                ></totp-mfa-registration>

                <backup-code
                    *ngIf="(loginPageStep$ | async) === loginPageStep.BackupCode"
                ></backup-code>
            </div>
        </div>
    `
})
export class LoginPageComponent implements OnInit, OnDestroy {
    public loginPageStep$ = this._loginService.loginPageStep$;
    public loginPageStep = LoginPageStep;
    public displayPasswordReset = false;
    public isLoading = false;

    constructor(private _loginService: LoginService) {}

    public ngOnInit(): void {
        this._loginService.routeParams$.pipe(forLifeOf(this)).subscribe(async (params) => {
            this.isLoading = true;
            if (!!params.get(FastTrackRouteQueryParams.MultiFactorAuthenticationSetup)) {
                await this._loginService.refreshUser();
            }

            if (!!params.get(FastTrackRouteQueryParams.VerificationCode)) {
                this._loginService.setLoginPageStep(LoginPageStep.ForgotPasswordVerification);
            }

            if (!!params.get(FastTrackRouteQueryParams.ShowPasswordReset)) {
                this.displayPasswordReset = true;
            }
            this.isLoading = false;
        });
    }

    public ngOnDestroy() {
        this._loginService.setLoginPageStep(LoginPageStep.SignIn);
    }
}
